export default {
    title: 'Adopt trends from workspace',
    subtitle: 'Select a workspace whose macro trends you want to have evaluated',
    select: {
        label: 'Select workspace'
    }
}
